import { MatDialogRef } from '@angular/material/dialog';
import { AbsenceReportDialogData } from '@app/components/dialogs/absence-report-dialog/absence-report-dialog-data';
import { AbsenceReportDialogComponent } from '@app/components/dialogs/absence-report-dialog/absence-report-dialog.component';
import { TimeReportDialogComponent } from '@app/components/time-reports/time-report-dialog/time-report-dialog.component';
import { DialogService } from '@app/shared/services/shared/dialog.service';
import { TimeReportsDataService } from '@app/shared/services/time-reports-data.service';
import { isAbsenceReport } from '@app/shared/types/models/reports/absence-report';
import { TimeReport } from '@app/shared/types/models/reports/time-report';
import { resolveTimeReportDialogType } from '@app/shared/utils/time-report-table.utils';

export type MixedReportsEditDialogRef =
  MatDialogRef<TimeReportDialogComponent, unknown> | MatDialogRef<AbsenceReportDialogComponent, boolean> | undefined;

export function openMixedReportsEditDialog(
  dialogService: Pick<DialogService, 'openTimeReportDialog' | 'openAbsenceReportDialog'>,
  report: TimeReport,
  range: { start: Date; end: Date }
): MixedReportsEditDialogRef {
  const dialogType = resolveTimeReportDialogType(report);
  if (dialogType === 'WorkTime') {
    return dialogService.openTimeReportDialog(undefined, report, undefined, 'WorkTime', range.start, range.end);
  }
  if (dialogType === 'Absence' && isAbsenceReport(report)) {
    const data: AbsenceReportDialogData = {
      report,
      dateFrom: range.start,
      dateTo: range.end
    };
    return dialogService.openAbsenceReportDialog(data);
  }
  return undefined;
}

export function handleMixedReportsEditClosed(
  report: TimeReport,
  result: unknown,
  range: { start: Date; end: Date },
  timeReports: Pick<TimeReportsDataService, 'loadTimeReports' | 'reloadTimeReports'>
): void {
  if (!result) {
    return;
  }

  if (isAbsenceReport(report)) {
    timeReports.reloadTimeReports(range.start, range.end);
    return;
  }

  // Force a canonical refetch: updateWorkTimeReport does not re-index range membership, so a
  // date-changing edit must rebuild the collection; it also reconciles backend-calculated values.
  timeReports.reloadTimeReports(range.start, range.end);
}
